import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ConfirmModal from "../Confirm";
import { deleteFolder } from "../../../../store/File/actions";
import { openModal } from "../../../../store/Modals/actions";
import {
  MODAL_DELETE_FOLDER,
  MODAL_CONFIRM,
} from "../../../../store/Modals/constants";
import { CONFIRM_DELETE_MESSAGE } from "../Confirm/constants";

const DeleteFolder = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openModal(MODAL_CONFIRM));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConfirmModal
      modal={MODAL_DELETE_FOLDER}
      action={() => dispatch(deleteFolder())}
      message={CONFIRM_DELETE_MESSAGE}
    />
  );
};

export default DeleteFolder;
